import styled from "styled-components";

export const CustomerWrapper = styled.div`
  display: flex;
  height: 100%;
  background: #f5f7fb;
  color: #131a29;
  overflow: hidden;
`;

export const CustomerSidebarWrapper = styled.aside`
  width: 240px;
  background: #eef2f7;
  border-right: 1px solid #dde3ee;
  padding: 40px 0;
`;

export const CustomerSidebarList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const CustomerSidebarItem = styled.li<{ active?: boolean }>`
  button {
    width: 100%;
    border: none;
    background: ${(props) => (props.active ? "#1c65b5" : "transparent")};
    color: ${(props) => (props.active ? "#ffffff" : "#4a4f5c")};
    font-weight: ${(props) => (props.active ? 600 : 500)};
    text-align: left;
    padding: 14px 32px;
    cursor: ${(props) => (props.active ? "default" : "pointer")};
    transition: background 0.2s ease;
    font-size: 15px;
    display: flex;
    align-items: center;
    gap: 10px;

    &:hover {
      background: ${(props) => (props.active ? "#1c65b5" : "#dfe7f3")};
    }
  }
`;

export const CustomerContent = styled.section`
  flex: 1;
  padding: 48px 64px;
  overflow-y: auto;

  @media (max-width: 960px) {
    padding: 32px 24px;
  }
`;

export const CustomerGreeting = styled.div`
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const CustomerSubTitle = styled.div`
  color: #6b7280;
  margin-bottom: 32px;
`;

export const CustomerPanel = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #edf0f6;
  box-shadow: 0 30px 50px rgba(20, 33, 77, 0.08);
  padding: 32px;
`;

export const CustomerSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const CustomerSectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
`;

export const CustomerTableCard = styled(CustomerPanel)`
  padding: 24px;
`;

export const EmptyState = styled.div`
  padding: 48px;
  text-align: center;
  color: #868c9f;
  font-size: 16px;
`;

export const BookingDetailsWrapper = styled.div`
  .details-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
    margin-bottom: 32px;
  }

  .details-block {
    background: #f8fafc;
    border-radius: 10px;
    padding: 16px;
    border: 1px solid #e3e8f4;
  }

  .details-block strong {
    display: block;
    color: #4a4f5c;
    font-size: 13px;
    text-transform: uppercase;
    margin-bottom: 6px;
  }

  .details-block span {
    font-size: 16px;
    color: #0f172a;
    font-weight: 600;
  }

  .details-table {
    width: 100%;
    border-collapse: collapse;
  }

  .details-table td,
  .details-table th {
    border: 1px solid #e3e8f4;
    padding: 12px;
    font-size: 14px;
    text-align: left;
  }

  .details-table th {
    background: #f5f7fb;
    text-transform: uppercase;
    font-weight: 600;
    color: #4a4f5c;
  }
`;

export const BookingHighlight = styled.div`
  background: #ffe4e6;
  border-radius: 12px;
  padding: 20px;
  margin-top: 24px;
  border: 1px solid #fecdd3;

  h4 {
    margin: 0 0 12px;
    color: #be123c;
    font-weight: 600;
  }
`;
